import { Component, input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VariableEditorType } from '../../../../../modals/edit-custom-input-text-modal/variable-editor.service';
import {
  requiredHiddenFieldValidator,
  ZiroCustomInputTextConfig,
} from '../../../../../shared/custom-configs/custom-input-text/ziro-custom-input-text.component';
import { CustomInputText, LdapPublicConfiguration } from '../../../../../shared/models/generated/ziroModels';
import { ZiroFormAbstractDirective } from '../../../../../forms/ziro-form-abstract.directive';

export interface CiscoWriteToLdapFormEntity {
  e164_ldap: CustomInputText;
  extension_ldap: CustomInputText;
}

export interface CiscoWriteToLdapFormData {
  e164_ldap: CustomInputText;
  extension_ldap: CustomInputText;
}

@Component({
  selector: 'ziro-cisco-dial-plan-management-write-to-ldap-form',
  templateUrl: './dial-plan-management-write-to-ldap-form.component.html',
  standalone: false,
})
export class CiscoDialPlanManagementWriteToLdapFormComponent extends ZiroFormAbstractDirective<
  CiscoWriteToLdapFormEntity | CiscoWriteToLdapFormData
> {
  readonly ldapConfiguration = input<LdapPublicConfiguration>();

  formConfig = {
    fields: {
      e164_ldap: {
        label: 'tkey;dialplanmanagement.admin.group.writeldap.e164',
        dataAutomation: 'write-to-ldap-e164',
        componentConfig: new ZiroCustomInputTextConfig({
          editorType: VariableEditorType.CISCO,
          isAlwaysRequired: false,
          hideCheckboxes: false,
          hideEditorButton: false,
          hidePreview: false,
        }),
        disabled: () => !this.ldapConfiguration().e164NumberAttributeName,
        disabledTooltip: 'tkey;dialplanmanagement.admin.group.writeldap.disabledtooltip',
        validation: [requiredHiddenFieldValidator],
      },
      extension_ldap: {
        label: 'tkey;dialplanmanagement.admin.group.writeldap.extension',
        dataAutomation: 'write-to-ldap-extension',
        componentConfig: new ZiroCustomInputTextConfig({
          editorType: VariableEditorType.CISCO,
          isAlwaysRequired: false,
          hideCheckboxes: false,
          hideEditorButton: false,
        }),
        disabled: () => !this.ldapConfiguration().extensionAttributeName,
        disabledTooltip: 'tkey;dialplanmanagement.admin.group.writeldap.disabledtooltip',
        validation: [requiredHiddenFieldValidator],
      },
    },
  };

  submit(): Observable<null> {
    return of(null);
  }

  toFormData = (entity: CiscoWriteToLdapFormEntity): CiscoWriteToLdapFormData => {
    return {
      e164_ldap: {
        name: entity.e164_ldap?.name,
        value: entity.e164_ldap?.value,
        required: entity.e164_ldap?.required,
        show: entity.e164_ldap?.show,
      },
      extension_ldap: {
        name: entity.extension_ldap?.name,
        value: entity.extension_ldap?.value,
        required: entity.extension_ldap?.required,
        show: entity.extension_ldap?.show,
      },
    };
  };

  toEntity = (formData: CiscoWriteToLdapFormData): CiscoWriteToLdapFormEntity => {
    return {
      e164_ldap: {
        name: formData.e164_ldap.name,
        required: formData.e164_ldap.required,
        show: formData.e164_ldap.show,
        value: formData.e164_ldap.value,
      },
      extension_ldap: {
        name: formData.extension_ldap.name,
        required: formData.extension_ldap.required,
        show: formData.extension_ldap.show,
        value: formData.extension_ldap.value,
      },
    };
  };
}
